import { OrganizationRole } from '@/enums/roles';
import Document from '@/views/documents/Document.vue';
import Documents from '@/views/documents/Documents.vue';
import type { RouteRecordRaw } from 'vue-router';

const routes: readonly RouteRecordRaw[] = [
    {
        path: '/documenten/:module/:path(.*)',
        name: 'document',
        component: Document,
        meta: {
            pageTitle: 'Document',
            roles: [OrganizationRole.Employee]
        }
    },
    {
        path: '/documenten/:module',
        name: 'documents',
        component: Documents,
        meta: {
            pageTitle: 'Documenten',
            roles: [OrganizationRole.Employee]
        }
    }
];

export default routes;
